import { useNavigate } from "react-router";
import { applySearchParamsToPath } from "../utils/url.ts";

export const usePreserveSearchParamsNavigate = () => {
  const navigate = useNavigate();
  return (to: string) => {
    navigate(applySearchParamsToPath(to));
  };
};
